// R6 — run fn once the page has loaded and settled (so non-critical code never competes
// with the first paint, the API calls or the hero image). Returns a cancel function.
export function afterLoad(fn, delay = 3000) {
  let t = null;
  let done = false;
  const idle = window.requestIdleCallback || ((f) => setTimeout(f, 50));
  const run = () => { t = setTimeout(() => idle(() => { if (!done) { done = true; fn(); } }, { timeout: 2000 }), delay); };
  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run, { once: true });
  return () => { done = true; if (t) clearTimeout(t); window.removeEventListener('load', run); };
}

export default afterLoad;
